export const LOADING = 'loading' as const;
export const OPEN = 'open' as const;
export const MINIMISED = 'minimised' as const;
export const DISMISSED = 'dismissed' as const;

export type PanelState = typeof LOADING | typeof OPEN | typeof MINIMISED | typeof DISMISSED;

export type State = {
	panelState: PanelState;
	shouldRenderReopenSpotlight: boolean;
	shouldReopenPanel: boolean;
	votedCards: string[];
};

export type StoreActions = {
	getState: () => State;
	setState: (arg1: State) => void;
};
